import React, { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useApiCallMutation } from "../../Services/ApiCallService";
import { campaignModuleAPiEndPoints } from "../../Config/APIsEndpoints";
import { cloneErrors, cloneRequest } from "./cloneCampaignLogic";

const apiMessage = (response) => typeof response?.data === "string"
  ? response.data : response?.data?.message || "Campaign was not created";

const CloneCampaign = ({ open, source, onClose, onCreated }) => {
  const [cloneCampaign, mutation] = useApiCallMutation();
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [errors, setErrors] = useState({});
  const [result, setResult] = useState(null);
  const [anotherMode, setAnotherMode] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setPrice(source?.price == null ? "" : String(source.price));
      setErrors({});
      setResult(null);
      setAnotherMode(false);
    }
  }, [open, source?.campaignId, source?.price]);

  const submit = async (another) => {
    const found = cloneErrors({ name, price, requirePrice: another || anotherMode });
    setErrors(found);
    setResult(null);
    if (Object.keys(found).length) return;
    try {
      const response = await cloneCampaign({
        endPoint: campaignModuleAPiEndPoints.cloneCampaign(source.campaignId),
        method: "POST",
        data: cloneRequest({ name, price }),
      }).unwrap();
      if (response?.status?.code !== 200) {
        setResult({ severity: "error", text: apiMessage(response) });
        return;
      }
      const message = `Created ${name.trim()} (Paused)`;
      setResult({ severity: "success", text: message });
      onCreated?.(response.data, message);
      if (another) {
        setAnotherMode(true);
        setName("");
        setPrice("");
      } else {
        onClose?.();
      }
    } catch (error) {
      setResult({ severity: "error", text: typeof error?.data?.data === "string" ? error.data.data : "Campaign was not created" });
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Duplicate campaign</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography>Source: {source?.campaignName} (price ${source?.price ?? "—"})</Typography>
          <TextField label="Name" value={name} onChange={(event) => setName(event.target.value)}
            error={!!errors.name} helperText={errors.name} autoFocus />
          <TextField label="Buyer price" type="number" value={price}
            onChange={(event) => setPrice(event.target.value)} error={!!errors.price} helperText={errors.price}
            inputProps={{ min: 0.01, max: 10000, step: 0.01 }} />
          <Typography variant="body2">
            Copies integration (credentials by reference), filters, PL/DNPL, schedule and caps, tags.
            The copy starts Paused and is not added to any ping tree.
          </Typography>
          {result && <Alert severity={result.severity}>{result.text}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => submit(false)} disabled={mutation?.isLoading}>Create</Button>
        <Button onClick={() => submit(true)} disabled={mutation?.isLoading}>Create &amp; clone another</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneCampaign;
